import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import axios from 'axios';
import Vuex from 'vuex';

import ViewUI from 'view-design';

// 兼容IE10
import'@babel/polyfill';

// import style
import 'view-design/dist/styles/iview.css';

Vue.use(ViewUI);

// 阿里巴巴矢量图
import '../public/icon_font/iconfont.css'
import '../public/icon_font/iconfont.js'

// 时间
import moment from 'moment';

Vue.prototype.$moment = moment;


import VueCropper from 'vue-cropper'
Vue.use(VueCropper)



// 自己封装的this.$Message.info
import  alert from '@/api/messageInfo.js';
Vue.prototype.$alert = alert;

// 自己封装route请求，不通过，则按钮不可点击
import canBtn from '@/api/canBtn.js';
Vue.prototype.$canBtn = canBtn;
// 自己封装ajax 的data 中有键值为 null 
import ajax_null from '@/api/ajax_data_null.js';
Vue.prototype.$ajaxNull = ajax_null;
// 获取的数据为null,自动转为 "N/A"
import data_null from '@/api/data_null.js';
Vue.prototype.$data_null = data_null;

// 数组 [],自动转为 字符串 " | "
import split from '@/api/split.js';
Vue.prototype.$split = split;


// 自己封装axios请求
import myAjax from '@/api/myAjax.js';
Vue.prototype.$myAjax = myAjax;
// 自己封装 上传upload 的axios 请求
import upload from '@/api/upload_img.js';
Vue.prototype.$upload = upload;

// 引入video
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video

// 引入audio  的美观插件vue-aplayer 
import vueAplayer from 'vue-aplayer'
Vue.use(vueAplayer)


import store from './store' //引入状态管理 store


import '@/api/axios.js';
Vue.prototype.$ajax = axios;

Vue.use(Vuex)

Vue.config.productionTip = false;

// 路由变化跳转页面回到顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})


router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start();
  next();
});

router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
